/* eslint-disable security/detect-object-injection */
import { Icon } from '@jutro/components';
import { TranslatorContext, withIntl } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { DatatableUtil } from '@xengage/gw-portals-util-js';
import { SHOW_ALL_PAGES } from '@jutro/legacy/datatable';
import appConfig from 'app-config';
import { ENTGatewayClaimService } from 'ent-capability-gateway-claim';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { SelectProducerCode } from 'gw-gateway-common-react';
import _ from 'lodash';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { UserService } from 'gw-capability-gateway';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import messages from 'gw-capability-gateway-claim-react/Claims.messages';
import pageMessages from './ClaimsLanding.messages'
import metadata from './ClaimsLanding.metadata.json5';
import styles from './ClaimsLanding.module.scss';

const { gatewayParamConfig = {} } = appConfig;

class ClaimsLanding extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func,
        }).isRequired,
    };

    state = {
        currentView: 'recentlyViewedTile',
        selectedProducerCode: 'all',
        selectedHeaderContent: messages.recentlyViewed,
        producerCode: [],
        producerCodes: [],
        claimQuery: '',
        searchByReportedDateExt: false,
        searchByLossDateExt: false,
        showClosed: false,
        fromDateExt: undefined,
        toDateExt: undefined,
        offsetStartValue: undefined,
        offsetEndValue: undefined,
        showErrors: false,
        showDateValidation: false,
        claimsSearchData: [],
        pageConfig: {
            filterValue: "",
            page: 0,
            pageSize: 25
        }
    };

    componentDidMount() {
        this.getProducerCodes();
    };

    componentDidUpdate(preProp, preState) {
        const {
            searchByReportedDateExt,
            searchByLossDateExt,
            fromDateExt,
            toDateExt,
            showClosed,
            claimQuery,
            currentView
        } = this.state;

        if (preState.searchByReportedDateExt !== searchByReportedDateExt ||
            preState.searchByLossDateExt !== searchByLossDateExt ||
            preState.fromDateExt !== fromDateExt || preState.toDateExt !== toDateExt ||
            preState.showClosed !== showClosed || preState.claimQuery !== claimQuery
        ) {
            this.searchClaims()
        }

        if (preState.currentView !== currentView && currentView === 'searchClaimsTile') {
            this.searchClaims();
        }
    }

    getProducerCodes = () => {
        let { producerCode } = this.state;
        let { producerCodes } = this.state;
        const { authHeader } = this.props;

        UserService.getAvailableProducerCodesForCurrentUser(authHeader).then(
            producerCodeResponse => {
                if (producerCodeResponse?.length === 1) {
                    producerCode = _.sortBy(producerCodeResponse, 'code').map(
                        value => {
                            return {
                                code: value.code,
                                name: `${value.displayValue} ${value.description}`,
                            };
                        }
                    );
                    this.setState({ producerCode })
                } else {
                    producerCodes = _.sortBy(producerCodeResponse, 'code').map(
                        value => {
                            return {
                                code: value.code,
                                name: `${value.displayValue} ${value.description}`,
                            };
                        }
                    );
                    this.setState({ producerCodes })
                }
            }
        );
    };

    processResponseData = responseData => {
        const { authUserData } = this.props
        const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

        if (!_.isEmpty(responseData)) {
            return responseData.map(claimInfo => {
                const claims = {
                    type: claimInfo.isPersonalAccount
                        ? 'Personal'
                        : 'Commercial',
                    product: claimInfo.product,
                    account: claimInfo.insuredName,
                    claimNumber: claimInfo.claimNumber,
                    dateOfLoss: claimInfo.dateOfLoss,
                    status: claimInfo.state,
                    paid: isTFPA ? claimInfo.indemnityPayments_TFPA : claimInfo.indemnityPayments_TWIA,
                    netIncurred: claimInfo.totalIncurredNet,
                    policyNumber: claimInfo.policyNumber,
                    accountNumber: claimInfo.accountNumber,
                    mailingAddress: isTFPA ? claimInfo.mailingAddress_TFPA : claimInfo.lossLocation_TWIA,
                    reportedDate: isTFPA ? claimInfo.reportedDate_TFPA : claimInfo.reportedDate_TWIA
                };

                return claims;
            });
        }

        return [];
    };

    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            product: translator(messages.product),
            dateOfLoss: translator(messages.dateOfLoss),
            status: translator(messages.status),
        };

        return <span title={toolTipMessage[property]}>{item[property]}</span>;
    };

    getLocationCell = (item, index, { id: property }) =>
    (
        <div className={styles.locationCell}>
            <div className={styles.locationCellDetails} title={item[property]}>{item[property]}</div >
        </div>
    )


    getCurrencyCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            paid: translator(messages.totalPayments),
            netIncurred: translator(messages.totalIncurrednet),
        };
        
        if(item[property]?.amount === 0) {
            return (
                <span>
                    <CurrencyField
                        id={`claimsCurrency_${index}`}
                        value="-"
                        datatype="string"
                        readOnly
                        hideLabel
                    />
                </span>
            );
        }

        return (
            <span title={toolTipMessage[property]}>
                <CurrencyField
                    id={`claimsCurrency_${index}`}
                    value={item[property]}
                    datatype="object"
                    readOnly
                    hideLabel
                />
            </span>
        );
    };

    getAccount = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = translator(messages.account);
        const icon =
            item.type === 'Personal' ? 'mi-account_circle' : 'mi-apartment';

        return (
            <div className={styles.linkAccount}>
                <Icon icon={icon} className={styles.gwClaimsAccountIcon} />
                <Link
                    to={`/accounts/${item.accountNumber}/summary`}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            </div>
        );
    };

    handleOnClick = id => {
        this.setState({ currentView: id });
    };

    handleValueChange = producerCode => {
        this.setState({
            selectedProducerCode: producerCode,
        });
    };

    handleValidation = () => {
        this.setState({ showErrors: true });
    };

    handleSearchClaimsFilter = (value, path) => {
        switch (path) {
            case 'searchByReportedDateExt':
                this.setState({ searchByReportedDateExt: value });
                break;
            case 'searchByLossDateExt':
                this.setState({ searchByLossDateExt: value });
                break;
            case 'showClosed':
                this.setState({ showClosed: value });
                break;
            case 'fromDateExt':
                this.setState({ fromDateExt: value });
                break;
            case 'toDateExt':
                this.setState({ toDateExt: value });
                break;
            case 'claimQuery':
                this.setState({ claimQuery: value });
                break;
            default:
        }
    };

    getLink = (item, index, { id: property }) => {
        const translator = this.context;
        let toolTipMessage = translator(messages.claimNumber);

        if (property === 'policyNumber') {
            toolTipMessage = translator(messages.policyNumber);

            return (
                <Link
                    to={`/policies/${item[property]}/summary`}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }

        if (
            item.status ===
            translator({
                id: 'typekey.ClaimState.draft',
                defaultMessage: 'Draft',
            })
        ) {
            const redirectpath = {
                pathname: '/fnol-select-policy',
                state: {
                    claimNumber: item[property],
                    redirectPath: '/claims',
                    claimStatus: item.status,
                },
            };

            return (
                <Link
                    to={redirectpath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }

        const redirectpath = {
            pathname: `/claims/${item[property]}`,
            state: {
                claimNumber: item[property],
                redirectPath: '/claims',
                claimStatus: item.status,
            },
        };

        return (
            <Link
                to={redirectpath}
                className={styles.gwClaimsLinkContent}
                title={toolTipMessage}
            >
                {item[property]}
            </Link>
        );
    };

    recentView = (pageSize, page, sorted) => {
        const { authHeader } = this.props;

        return ENTGatewayClaimService.getRecentlyViewedClaims(authHeader).then(
            response => {
                this.setState({
                    selectedHeaderContent: messages.recentlyViewed,
                });

                const data = this.processResponseData(response);
                const sortedData = _.orderBy(
                    data,
                    sorted.map(
                        ({ id }) =>
                            row =>
                                row[id]
                    ),
                    sorted.map(({ desc }) => (desc ? 'desc' : 'asc'))
                );

                const paginatedData = pageSize === SHOW_ALL_PAGES ? sortedData : sortedData.slice( 
                    pageSize * page,
                    pageSize * page + pageSize
                );

                const result = {
                    rows: paginatedData,
                    numberOfRows: sortedData.length,
                };

                return result
            }
        );
    };

    recentCreated = (paginationParams, paramProducerCode, sorted) => {
        const { authHeader } = this.props;
        let claimsPromise = null;

        claimsPromise = _.isNull(paramProducerCode)
            ? ENTGatewayClaimService.getClaimsForCurrentUser(
                [
                    gatewayParamConfig.claimsCreatedInLastXDays,
                    paginationParams,
                    paramProducerCode,
                ],
                authHeader
            )
            : ENTGatewayClaimService.getClaimsForProducerCode(
                [
                    gatewayParamConfig.claimsCreatedInLastXDays,
                    paginationParams,
                    paramProducerCode,
                ],
                authHeader
            );

        return claimsPromise.then(response => {
            this.setState({
                selectedHeaderContent: messages.recentlyCreated,
            });

            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(
                data,
                sorted.map(
                    ({ id }) =>
                        row =>
                            row[id]
                ),
                sorted.map(({ desc }) => (desc ? 'desc' : 'asc'))
            );

            return {
                rows: sortedData,
                numberOfRows: response.maxNumberOfResults,
            };
        });
    };

    openClaims = (paginationParams, paramProducerCode, sorted) => {
        const { authHeader } = this.props;
        let claimsPromise = null;

        claimsPromise = _.isNull(paramProducerCode)
            ? ENTGatewayClaimService.getOpenClaimsForCurrentUser(
                [
                    gatewayParamConfig.claimsCreatedInLastXDays,
                    paginationParams,
                    paramProducerCode,
                ],
                authHeader
            )
            : ENTGatewayClaimService.getOpenClaimsForProducerCode(
                [
                    gatewayParamConfig.claimsCreatedInLastXDays,
                    paginationParams,
                    paramProducerCode,
                ],
                authHeader
            );

        return claimsPromise.then(response => {
            this.setState({
                selectedHeaderContent: messages.openClaims,
            });

            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(
                data,
                sorted.map(
                    ({ id }) =>
                        row =>
                            row[id]
                ),
                sorted.map(({ desc }) => (desc ? 'desc' : 'asc'))
            );

            return {
                rows: sortedData,
                numberOfRows: response.maxNumberOfResults,
            };
        });
    };

    handleFileClick = () => {
        const {
            history
        } = this.props;
        const redirectClaimsPath = `/claims`;

        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                redirectPath: redirectClaimsPath,
            },
        });
    };

    closedClaims = (paginationParams, paramProducerCode, sorted) => {
        const { authHeader } = this.props;
        let claimsPromise = null;

        claimsPromise = _.isNull(paramProducerCode)
            ? ENTGatewayClaimService.getClosedClaimsForCurrentUser(
                [
                    gatewayParamConfig.claimsCreatedInLastXDays,
                    paginationParams,
                    paramProducerCode,
                ],
                authHeader
            )
            : ENTGatewayClaimService.getClosedClaimsForProducerCode(
                [
                    gatewayParamConfig.claimsCreatedInLastXDays,
                    paginationParams,
                    paramProducerCode,
                ],
                authHeader
            );

        return claimsPromise.then(response => {
            this.setState({
                selectedHeaderContent: messages.closedClaims,
            });

            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(
                data,
                sorted.map(
                    ({ id }) =>
                        row =>
                            row[id]
                ),
                sorted.map(({ desc }) => (desc ? 'desc' : 'asc'))
            );

            return {
                rows: sortedData,
                numberOfRows: response.maxNumberOfResults,
            };
        });
    };

    localDateFromDate = (localDate) => {
        const dateTime = new Date();

        dateTime.setHours(0, 0, 0, 0);
        dateTime.setFullYear(localDate.year);
        dateTime.setMonth(localDate.month);
        dateTime.setDate(localDate.day);

        return dateTime;
    };

    localDateToDate = (localDate) => {
        const dateTime = new Date();

        dateTime.setHours(23, 59, 59, 999);
        dateTime.setFullYear(localDate.year);
        dateTime.setMonth(localDate.month);
        dateTime.setDate(localDate.day);

        return dateTime;
    };

    searchClaims = () => {
        const { authHeader, viewModelService } = this.props;
        const { selectedProducerCode, searchByReportedDateExt, producerCodes, producerCode, searchByLossDateExt,
            showClosed, claimQuery, fromDateExt, toDateExt, offsetStartValue, offsetEndValue, pageConfig } = this.state;

        this.setState({
            selectedHeaderContent: messages.searchClaims,
        });

        if ((searchByReportedDateExt || searchByLossDateExt) && (fromDateExt === undefined || toDateExt === undefined)) {
            this.handleValidation()

            return false
        }

        const queryOptions = {
            offsetStart: offsetStartValue,
            offsetEnd: offsetEndValue,
            orderBy: 'CreateTime',
            orderByDescending: true
        };

        let claimsPromise = null;
        const lastXDate = new Date();
        const searchProducerCodes = [];
        let includeMigratedPolicies = true;
        const states = ['open'];
        const dto = viewModelService.create({}, 'cc', 'edge.capabilities.claim.dto.ClaimSearchDTO');

        dto.searchByReportedDateExt.value = searchByReportedDateExt
        dto.searchByLossDateExt.value = searchByLossDateExt
        dto.queryText.value = claimQuery;

        if (fromDateExt !== undefined) {
            dto.fromDateExt.value = this.localDateFromDate(fromDateExt);
        }

        if (toDateExt !== undefined) {
            dto.toDateExt.value = this.localDateToDate(toDateExt);
        }

        const isDataValid = dto.aspects.valid && dto.aspects.subtreeValid;
        
        this.setState({ showDateValidation: false });

        if (!isDataValid) {
            this.setState({ showDateValidation: true });

            return false;
        }

        if (showClosed) {
            states.push('closed');
        }

        dto.claimStates = states;
        lastXDate.setFullYear(lastXDate.getFullYear() - 7);

        const lastXDays = (new Date().getTime() - lastXDate.getTime()) / (24 * 60 * 60 * 1000);

        if (selectedProducerCode === 'all' && producerCodes?.length > 1) {
            producerCodes.forEach(theCode => searchProducerCodes.push(theCode.code));
            includeMigratedPolicies = true;
        } else {
            producerCode.forEach(theCode => searchProducerCodes.push(theCode.code));
        }

        claimsPromise = _.isNull(selectedProducerCode)
            ? ENTGatewayClaimService.getAdvanceClaimSearchResultsForCurrentUser(
                [
                    lastXDays,
                    queryOptions,
                    searchProducerCodes,
                    dto.value,
                    includeMigratedPolicies
                ],
                authHeader
            )
            : ENTGatewayClaimService.getAdvanceClaimSearchResultsForCurrentUser(
                [
                    lastXDays,
                    queryOptions,
                    searchProducerCodes,
                    dto.value,
                    includeMigratedPolicies
                ],
                authHeader
            );

        return claimsPromise.then(response => {
            const data = this.processResponseData(response.claims);

            this.setState({
                claimsSearchData: data
            });


            if ((searchByReportedDateExt || searchByLossDateExt) || claimQuery.length > 0) {
                pageConfig.page = 0
            }

            this.setState({
                pageConfig
            })

            return {
                rows: data,
                numberOfRows: response.maxNumberOfResults,
            };
        });
    };

    loadData = ({ sorted, pageSize, page }) => {
        const { currentView, selectedProducerCode } = this.state;
        const paramProducerCode =
            selectedProducerCode === 'all' ? null : selectedProducerCode;
        let tile = 'recentlyViewedTile';

        if (currentView) {
            tile = currentView;
        }

        const startIndex = pageSize * page;
        const offsetEndMinusOne = startIndex + pageSize - 1;
        const paginationParams = {
            offsetStart: startIndex,
            offsetEnd: offsetEndMinusOne,
            orderBy: gatewayParamConfig.landingOrderBy,
            orderByDescending: gatewayParamConfig.landingOrderByDescending,
        };

        this.setState({ offsetStartValue: startIndex });
        this.setState({ offsetEndValue: 8 * offsetEndMinusOne });

        if (tile === 'recentlyViewedTile') {
            return this.recentView(pageSize, page, sorted);
        }

        if (tile === 'recentlyCreatedTile') {
            return this.recentCreated(
                paginationParams,
                paramProducerCode,
                sorted
            );
        }

        if (tile === 'openClaimsTile') {
            return this.openClaims(paginationParams, paramProducerCode, sorted);
        }

        if (tile === 'closedClaimsTile') {
            return this.closedClaims(
                paginationParams,
                paramProducerCode,
                sorted
            );
        }
        
        return { rows: [], numberOfRows: 0 };
    };

    dateFormatValue = (items,index,path) => {
        const { intl } = this.props;

        return intl.formatDate(
            new Date(items[path.path]),
            {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            }
        );
    };

    render() {
        const { currentView, selectedProducerCode, selectedHeaderContent, searchByReportedDateExt, searchByLossDateExt,
            showClosed, fromDateExt, toDateExt, showErrors, claimQuery, claimsSearchData, showDateValidation } =
            this.state;
        const { authUserData, setComponentValidation } = this.props
        const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
        const translator = this.context;
        const tableKey = currentView + selectedProducerCode;
        const overrides = {
            claimsTableContainer: {
                visible: currentView !== 'searchClaimsTile',
            },
            recentlyViewedTableGrid: {
                onFetchData: this.loadData,
                key: tableKey,
            },
            [currentView]: {
                active: true,
            },
            recentlyViewedId: {
                content: translator(selectedHeaderContent),
                visible: currentView !== 'searchClaimsTile'
            },
            paidColumnTitle: {
                visible:
                    appConfig.persona === 'producer' ||
                    appConfig.persona === 'csr',
            },
            reportedDateColumnTFPATitle: {
                visible: isTFPA
            },
            reportedDateColumnTWIATitle: {
                visible: !isTFPA
            },
            mailAddressColumnTitle: {
                header: isTFPA ? translator(pageMessages.mailingAddress) : translator(pageMessages.primaryLossLocation)
            },
            statusColumnTitle:{
                visible: isTFPA || currentView === 'searchClaimsTile'
            },
            // DE17203
            claimsInfoNotification: {
                message: isTFPA ? translator(pageMessages.tfpaClaimVerbiage) : translator(pageMessages.twiaClaimVerbiage),
                visible: currentView !== 'searchClaimsTile'
            },
            claimsSearchNotification: {
                message: isTFPA ? translator(pageMessages.tfpaClaimsSearchNotification) : translator(pageMessages.twiaClaimsSearchNotification),
                visible: currentView === 'searchClaimsTile'
            },
            searchClaimContainer: {
                visible: currentView === 'searchClaimsTile'
            },
            claimSearch: {
                visible: currentView === 'searchClaimsTile',
                value: claimQuery
            },
            searchByReportedDate: {
                value: searchByReportedDateExt
            },
            searchByLossDate: {
                value: searchByLossDateExt
            },
            closedClaimsLabel: {
                value: showClosed
            },
            fromDate: {
                value: fromDateExt,
                required: searchByReportedDateExt || searchByLossDateExt,
                showRequired: searchByReportedDateExt || searchByLossDateExt,
                showErrors
            },
            toDate: {
                value: toDateExt,
                required: searchByReportedDateExt || searchByLossDateExt,
                showRequired: searchByReportedDateExt || searchByLossDateExt,
                showErrors
            },
            claimsSearchTableContainer: {
                visible: currentView === 'searchClaimsTile',
            },
            claimsSearchTable: {
                data: claimsSearchData,
                config: this.state.pageConfig,
                onConfigChange: (data) => {
                    const pageConfig = _.clone(data)

                    if (claimsSearchData.length <= 25) {
                        pageConfig.page = 0
                    }

                    this.setState({
                        pageConfig
                    })
                }
            },
            toDateGreaterThanFromDate: {
                visible: currentView === 'searchClaimsTile' && showDateValidation,
                message: translator(pageMessages.toDateGreaterThanFromDate)
            },
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getLocationCell: this.getLocationCell,
                getCurrencyCell: this.getCurrencyCell,
                getAccount: this.getAccount,
                getLink: this.getLink,
                handleOnClick: this.handleOnClick,
                handleValueChange: this.handleValueChange,
                sortCurrency: DatatableUtil.sortCurrency,
                sortString: DatatableUtil.sortString,
                sortDate: DatatableUtil.sortDate,
                handleFileClick: this.handleFileClick,
                dateFormatValue: this.dateFormatValue,
                handleSearchClaimsFilter: this.handleSearchClaimsFilter
            },
            resolveComponentMap: {
                selectproducercode: SelectProducerCode,
            },
        };

        const claimsLandingpage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                onValidationChange={setComponentValidation}
                showErrors={showErrors}
                {...resolvers}
            />
        );

        return <div>{claimsLandingpage}</div>;
    }
}

export default withRouter(withViewModelService(withIntl(withAuthenticationContext(ClaimsLanding))));
